import dsBridge from 'dsbridge';
import router from 'umi/router';
// import { Toast } from 'antd-mobile';
const callbackFunctionName = '__JS_CALLBACK__';
const isProdEnv = process.env.NODE_ENV === 'production';
// const isProdEnv = true; // 临时测试
const logEnable = false;

// Flutter 与 H5 交互文档: http://wiki.onething.net/pages/viewpage.action?pageId=90867275
// http://wiki.onething.net/pages/viewpage.action?pageId=86116071

// 获取终端类型和版本(1.0.0)
export function getAppInfo() {
  if (isProdEnv) {
    if (isFlutterMode()) {
      return commonBridge('jsGetAppInfo');
    }
    return new Promise(resolve => {
      // 异步方法
      // dsBridge.call('jsGetAppInfo', {}, resolve);
      // 同步方法
      resolve(dsBridge.call('jsGetAppInfo'));
    });
  } else {
    return Promise.resolve({
      code: 0,
      message: 'ok',
      data: {
        origin: '3', // 终端类型，安卓为1，iOS为2,
        // version: '3.3.0',
        version: '4.5.5',
        // version: '2.2.0',
        channel: 'xiaomi', // 渠道号
        // 账号系统通用字段
        accountCommonFields: JSON.stringify({
          appId: '22017',
          appName: '网心云',
          clientVer: '999.9.9',
          deviceSign: 'c729abc06fcdeb31ebf18090fe13ee37',
          deviceName: 'evergo',
          deviceModel: '21091116AC',
          platType: '10',
          OSVer: '12',
          isp: 'NONE',
          netType: 'WIFI',
        }),
      },
    });
  }
}

/**
 * 在手机浏览器打开指定url(1.0.0+)
 * @param {Object} data - url: 要打开的链接地址
 */
export function openInBrowser(data) {
  console.log('jsOpenInBrowser: ', data);
  if (isFlutterMode()) {
    return commonBridge('jsOpenInBrowser', data);
  }
  return new Promise(resolve => {
    dsBridge.call('jsOpenInBrowser', data, resolve);
  });
}

// 调起原生修改设备备注弹窗(1.0.1)
export function renameDevice(data) {
  if (isFlutterMode()) {
    return commonBridge('jsRenameDevice', data);
  }
  return new Promise(resolve => {
    dsBridge.call('jsRenameDevice', data, resolve);
  });
}

/**
 * 新开webview(1.0.1)
 * @param {Object} data - url: 要打开的链接地址，在 APP 内部打开 URL
 */
export function openNewWebview(data) {
  console.log('openNewWebview', data.url);
  if (isFlutterMode()) {
    return commonBridge('jsOpenNewWebview', data);
  }
  return new Promise(resolve => {
    dsBridge.call('jsOpenNewWebview', data, resolve);
  });
}

/**
 * 复制(iOS 1.3.0)
 * @param {Object} data - text: 复制的信息
 */
export function copyEvent(data) {
  if (isFlutterMode()) {
    return commonBridge('jsCopyEvent', data);
  }
  return new Promise(resolve => {
    dsBridge.call('jsCopyEvent', data, resolve);
  });
}

// 跳转到相应收益指标的设备列表
export function showDeviceList(data) {
  if (isFlutterMode()) {
    return commonBridge('jsShowDeviceList', data);
  }
  return new Promise(resolve => {
    dsBridge.call('jsShowDeviceList', data, resolve);
  });
}

// 刷新token(终端不再需要，故删除)
/* export function refreshCookie() {
  if (isFlutterMode()) {
    return commonBridge('jsRefreshCookie', {});
  }
  return Promise.resolve();
} */

export function genRandomUUID() {
  let d = new Date().getTime();
  const uuid = 'xxxxxxxx'.replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

// 关闭 h5 页面（2.2.0+）
export function closeH5Native(callback) {
  if (isFlutterMode()) {
    console.log('关闭h5页面');
    return commonBridge('jsCloseWebPage', {}, callback);
  }
}

// 判断登录态(3.0.0+)
export function isLoginedNative() {
  // if (isProdEnv && isFlutterMode()) {
  if (isFlutterMode()) {
    return commonBridge('jsIsLogined', {});
  } else {
    return Promise.resolve({
      code: 0,
      message: 'ok',
      data: {
        status: true,
      },
    });
  }
}

/**
 * 通过原生方法打开任一原生页面或者H5页面，即，通用打开页面方法（推荐）（3.3.0+）
 * @param {Object} data
 * data = {url: 页面地址}
 * - 打开有赞页面携带登录态：youzan:encodeURIComponent(有赞链接)
 * - 打开 Flutter 页面，格式为 Flutter路由名字+参数，例如：
 * 使用 Flutter WebView 打开百度：page:web_view?url=https%3A%2F%2Fwww.baidu.com&is_fullscreen=true&title=%E7%99%BE%E5%BA%A6
 * - 打开原生 WebView 页面，格式为 android:encode_uri?title=encode_text，其中 encode_uri 为URL编码后的链接地址；title 参数为页面的固定标题，需要URL编码，可选。
 * 例如：android:https%3A%2F%2Fwww.baidu.com?title=%E7%99%BE%E5%BA%A6
 * - 打开系统页面，格式为 intent:encode_uri，其中 encode_uri 为URL编码后的链接地址，若 encode_uri 为 http/https 开头，可被系统浏览器处理。例如：
 * 使用系统浏览器打开百度：intent:https%3A%2F%2Fwww.baidu.com
 * 打开应用市场的微信下载页面：intent:market%3A%2F%2Fdetails%3Fid%3Dcom.tencent.mm
 * 5.5.0用这个链接打开小程序测速页面：
 * miniprogram:/homePages/pages/home/index?userName=gh_8e2fc84f0631
 */
export function openPageNative(data, options = { isMiniprogram: false }) {
  const compositingOptions = { isMiniprogram: false, ...options };
  if (compositingOptions.isMiniprogram) {
    // 如果是小程序过来的，链接后面拼接参数适配小程序页面展示和跳转
    if (data.url.includes('?')) {
      window.location.href = `${data.url}&comefrom=miniprogram`;
    } else {
      window.location.href = `${data.url}?comefrom=miniprogram`;
    }
    return;
  }
  if (isFlutterMode()) {
    return commonBridge('jsOpenPage', data);
  }
}

/**
 * 打开原生页面(3.0.0+)
 * @param {Object} data
 * data = {
    "path": "打开页面路径",
    "tab": 页面 tab,
    "params": {
        "key": "value"
     }
     @param {boolean} closeH5 是否关闭当前 h5页面，默认关闭，避免app 内存泄漏。当页面需要跳回来时，则不用关闭
}
 */
export function openNativePage(data, closeH5 = true, callback = () => {}) {
  console.log('jsOpenNativePage data: ', data);
  if (isFlutterMode()) {
    closeH5 && closeH5Native();
    return commonBridge('jsOpenNativePage', data, callback);
  }
}

// 使用 Android 原生 WebView 打开H5 页面,打开的H5页面不可以调用原生方法，用于客服、有赞页面
export function openNativeWebview(data) {
  console.log('data: ', data);
  if (isFlutterMode()) {
    return commonBridge('jsOpenNativeWebview', data);
  }
}

// 支付(3.0.0+)
export function toPayNative(data) {
  if (isFlutterMode()) {
    return commonBridge('jsPayOrder', data);
  }
}

// 注册全局方法，用于app回调(3.0.0+)
export function registerWindowFn(fnName, fn) {
  // console.log('registerWindowFn');
  if (typeof fn !== 'function') return;
  window[fnName] = fn;
}

/**
 * 允许缩放h5页面(3.0.0+)
 * @param {boolean} isResize 是否需要缩放页面，默认 true。(原生默认不缩放)
 */
export function resizePageNative(isResize = true) {
  if (isFlutterMode()) {
    const data = {
      is_resize: isResize,
    };
    return commonBridge('jsConfigResizeInfo', data);
  }
}

/**
 * 原生上报浏览页面信息(3.0.0+) 进入页面时上报
 * @param {Object} data
 *  - module 页面所属模块
 *  - page_name 页面名称
 */
export function reportPageNative(data) {
  if (isFlutterMode()) {
    return commonBridge('jsConfigWebPageInfo', data);
  }
}

/**
 * 原生上报埋点数据(3.0.0+)
 * @param {Object} data
 *  - event_id	事件id
 *  - attributes = {} 上报属性
 */
export function reportNative(data) {
  if (isFlutterMode()) {
    return commonBridge('jsAnalyticsEvent', data);
  }
}

function commonBridge(name, data, selfCallback) {
  const callback = `${callbackFunctionName}_${genRandomUUID()}`;
  if (logEnable) console.log(`__${name}__params: `, data);
  return new Promise(resolve => {
    window[callback] = function(res) {
      if (logEnable) console.log(`__${name}__res: `, res);
      resolve(res);
      window[callback] = undefined;
      typeof selfCallback === 'function' && selfCallback(res);
    };
    window.WebBridgeChannel.postMessage(
      JSON.stringify({
        method: name,
        params: data,
        callback: callback,
      })
    );
  });
}

export function isFlutterMode() {
  return typeof window.WebBridgeChannel !== 'undefined';
}

//RSA 加密方法
export function getRSAEncryption(data) {
  if (isFlutterMode()) {
    return commonBridge('jsRSAEncryption', data);
  }
  return new Promise(resolve => {
    // if (!navigator.onLine) {
    //   Toast.info('网络异常，请稍后再试');
    // } else {
    //   dsBridge.call('jsRSAEncryption', data, resolve);
    // }
    dsBridge.call('jsRSAEncryption', data, resolve);
  });
}

/**
 * 设置当前页面数据是否修改
 * @deprecated
 */
export function setPageDirty(data) {
  if (isFlutterMode()) {
    return commonBridge('jsSetPageDirty', data);
  }
  return new Promise(resolve => {
    dsBridge.call('jsSetPageDirty', data, resolve);
  });
}

// 定制标题导航栏(3.0.1+)
export function jsConfigAppBar(data) {
  if (isFlutterMode()) {
    return commonBridge('jsConfigAppBar', data);
  }
}

// 弹出硬盘(3.0.1+)
export function jsUnMountDisk(data) {
  if (isFlutterMode()) {
    return commonBridge('jsUnMountDisk', data);
  }
}

// 移除设备(3.0.1+)
export function jsUnbindDevice(data) {
  if (isFlutterMode()) {
    return commonBridge('jsUnbindDevice', data);
  }
}

/**
 * 单页应用 H5路由变化通知给终端，用于数据统计(3.0.1+)
 * @param {Object} data
 * data={url:"即将进入的页面链接"}
 */
export function jsNavigationDelegate(data) {
  console.log('jsNavigationDelegate', data);
  if (isFlutterMode()) {
    return commonBridge('jsNavigationDelegate', data);
  }
}

/**
 * 图片展示弹框(3.1.0+)
 * @param {Object} data
 * data={url:"图片链接"}
 */
export function viewPhotoNative(data) {
  if (isFlutterMode()) {
    return commonBridge('jsPhotoView', data);
  }
}

// H5 路由后退 (3.1.0+)
export function goBackNative() {
  if (isFlutterMode()) {
    console.log('goBackNative');
    return commonBridge('jsGoBack');
  } else {
    router.goBack();
  }
}

// H5获取批量选择设备信息列表(3.5.0 +)
export function jsGetDeviceListInfo() {
  if (isFlutterMode()) {
    console.log('jsDeviceList');
    return commonBridge('jsDeviceList');
  }
}

// 调用nabei(3.6.0+)
export function nabeiBridge(name, data, selfCallback = () => {}) {
  const callback = `${callbackFunctionName}_${genRandomUUID()}`;
  const postData = JSON.stringify({
    endpoint: 'CallNative',
    params: {
      action: name,
      ...data,
    },
    callback: callback,
  });
  console.log('postData: ', postData);
  // 判断是否是IOS端
  console.log('window.webkit: ', window.webkit);
  if (window.webkit !== undefined) {
    // 如果是IOS端
    return new Promise(resolve => {
      window[callback] = function(res) {
        resolve(res);
        window[callback] = undefined;
        typeof selfCallback === 'function' && selfCallback();
      };
      window.webkit.messageHandlers.nabei.postMessage(postData);
    });
  } else {
    // 安卓端
    return new Promise(resolve => {
      window[callback] = function(res) {
        resolve(res);
        window[callback] = undefined;
        typeof selfCallback === 'function' && selfCallback();
      };
      window.nabei.postMessage(postData);
    });
  }
}

export function nabeiTakePhoto(data, selfCallback) {
  return nabeiBridge('takePhoto', data, selfCallback);
}

export function nabeiIdCardException(data) {
  return nabeiBridge('idCardException', data);
}

export function nabeiSignSuccess(data) {
  return nabeiBridge('signSuccess', data);
}

// H5打开分享弹窗 (3.9.0+)
export function jsOpenShareDialog(data, callback = () => {}) {
  if (isFlutterMode()) {
    return commonBridge('jsOpenShareDialog', data, callback);
  }
}

// H5调用系统分享 (4.3.5+)
export function jsHandleShare(data, callback = () => {}) {
  if (isFlutterMode()) {
    return commonBridge('jsOpenShare', data, callback);
  }
}

// 二次验证页面(4.5.5+)
/**
 * @param {Object} data
 * @param {number} data.scene - 短信场景ID
 * @param {string} data.title - 二次验证页面标题栏文本
 * @param {string} data.desc - 二次验证页面居中显示文本
 * @param {number} data.backend - 短信后台，1为账号后台，其他值调用业务后台，默认值0
 * @param {string} data.button - 二次验证页面按键文本
 * @param {string} data.handler - H5函数名字，用户输入验证码后点确定时调用，传入一个字符串类型的验证码参数，如 handler("123456")
 * @param {function} [callback=()=>{}] - 该原生方法回调
 * @returns {Promise}
 */
export function jsOpenSmsVerificationPage(data, callback = () => {}) {
  console.log('jsOpenSmsVerificationPage data: ', data);
  if (isFlutterMode()) {
    return commonBridge('jsOpenSmsVerificationPage', data, callback);
  }
}

// H5 回调短信校验结果（4.5.5+）
/**
 * @param {Object} data
 * @param {string} data.result -  为后台返回的短信校验结果，不为空时原生会 toast 提示该文案；result 为空字符串时，原生关闭当前发送验证码界面。
 * @param {function} [callback=()=>{}] - 该原生方法回调
 * @returns
 */
export function jsSmsVerificationResult(data, callback = () => {}) {
  console.log('jsSmsVerificationResult data: ', jsSmsVerificationResult);
  if (isFlutterMode()) {
    return commonBridge('jsSmsVerificationResult', data, callback);
  }
}

/**
 * 打开APP设置页（4.7.0）
 */
export function jsOpenAppSettings(data, callback = () => {}) {
  if (isFlutterMode()) {
    return commonBridge('jsOpenAppSettings', data, callback);
  }
}

/**
 * 检查消息权限（4.7.0）
 * @param {object} data
 * @param {string} data.permission // 需要获取的权限名称
 * @returns
 */
export function jsCheckPermission(data, callback = () => {}) {
  if (isFlutterMode()) {
    return commonBridge('jsCheckPermission', data, callback);
  }
}

/**
 * 选择相册图片(5.0.0)
 * @param {function} callback 选择图片回调
 */
export function jsTakePhoto(callback = () => {}) {
  if (isFlutterMode()) {
    return commonBridge('jsTakePhoto', {}, callback);
  }
}

/**
 * 显示好评弹窗(5.1.0)
 * @param {object} data
 * @param {string} data.scene // 当前的场景
 * @returns
 */
export function jsShowAppReviewDialog(data, callback = () => {}) {
  if (isFlutterMode()) {
    return commonBridge('jsShowAppReviewDialog', data, callback);
  }
}

export function jsGetProxyAddress(data) {
  if (isFlutterMode()) {
    return commonBridge('jsGetProxyAddress', data);
  }
}

export function jsGetCookie(data) {
  if (isFlutterMode()) {
    return commonBridge('jsGetCookie', data);
  }
}
